/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import Popover, { PopoverContentWrapper } from '@deprecated-ui/common/Popover';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import screenerSlice, {
  screenerEffects,
  screenerSelectors,
} from 'features/screener/slice';
import {
  IDataScreenerCustom,
  IDataScreenerFavorites,
  ScreenerTemplateType,
} from 'features/screener/types';

import DeleteModal from '../../Modal/DeleteModal';

const ContentWrapper = styled(PopoverContentWrapper)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-width: 242px;
  border-radius: 3px !important;
  min-width: 200px;
  ::-webkit-scrollbar {
    width: 4px;
    height: 5px;
  }

  @media screen and (min-width: 720px) {
    ::-webkit-scrollbar-thumb {
      background: ${color.gainsboro};
      border: 0 ${color.aliceBlue};
      border-radius: 0;
    }
  }
`;

const SFlexItemFavoriteContainer = styled(Flex)`
  border-bottom: 1px solid ${color.gainsboro};
  &:last-child {
    border-bottom: none;
  }
`;

const SFlexItemFavorite = styled(Flex)`
  :hover {
    cursor: pointer;
  }
`;

const SButton = styled(Button)`
  :hover {
    p {
      color: ${color.primary};
    }
    background: ${color.aliceBlue};
  }
`;

const Menu = ({
  title,
  data,
  menuType,
  onClickStar,
  onClickLabel,
  onClickCross,
}: {
  title: string;
  data: IDataScreenerFavorites[] | IDataScreenerCustom[];
  menuType: 'favorite' | 'all';
  onClickStar: (
    e: React.SyntheticEvent<EventTarget>,
    screenerID: number,
    screenerType: ScreenerTemplateType,
  ) => void;
  onClickLabel: (guruID: number, type: ScreenerTemplateType) => void;
  // eslint-disable-next-line react/require-default-props
  onClickCross?: (
    e: React.SyntheticEvent<EventTarget>,
    screenerID: number,
    screenerName: string,
  ) => void;
}) => (
  // @ts-expect-error
  <SFlexItemFavoriteContainer direction="column" p="8px">
    <Text textTransform="uppercase" color={color.midgray} size="12px">
      {title}
    </Text>
    {data?.length === 0 && menuType === 'favorite' && (
      // @ts-expect-error
      <Text mt="8px" weight="400">
        You dont have any favorite screener
      </Text>
    )}

    {data.map(({ name, id, type, favorite }) => {
      if (favorite === 1 && menuType === 'all') {
        return null;
      }
      return (
        <SFlexItemFavorite
          justify="space-between"
          align="center"
          // @ts-expect-error
          pb="4px"
          height="30px"
          width="100%"
          onClick={() => {
            onClickLabel(id, type);
          }}
        >
          <Text width="calc(100% - 48px)" ellipsis>
            {name}
          </Text>
          {favorite === 0 && (
            <Iconmoon
              className="icon-trading_delete"
              onClick={(e) => {
                onClickCross(e, id, name);
              }}
            />
          )}
          <Iconmoon
            className={
              type === 'TEMPLATE_TYPE_GURU'
                ? 'icon-trading_star-fill'
                : menuType === 'favorite'
                ? 'icon-trading_star-fill'
                : 'icon-trading_star'
            }
            color={color.primary}
            onClick={(e) => {
              onClickStar(e, id, type);
            }}
          />
        </SFlexItemFavorite>
      );
    })}
  </SFlexItemFavoriteContainer>
);

const FavoriteDropdown = () => {
  // prettier-ignore
  const [screenerFavorites, setScreenerFavorites] = useState<IDataScreenerFavorites[]>([]);
  // prettier-ignore
  const [screenerCustom, setScreenerCustom] = useState<IDataScreenerCustom[]>([]);
  // prettier-ignore
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [deleteScreener, setDeleteScreener] = useState<{
    id: number;
    name: string;
  }>({ id: null, name: null });

  const {
    screenerFavorites: { data: dataFavorites },
    screenerCustom: { data: dataCustoms },
    removeScreenerCustomResult: { data: dataRemoveCustomResult },
  } = useSelector(screenerSelectors);

  const {
    removeFavorite,
    addFavorite,
    getScreenerCustom,
    getScreener,
    removeScreenerCustom,
  } = screenerEffects;

  const {
    actions: { setIsFormActive, setIsFormCreateMode, setIsFormEditMode },
  } = screenerSlice;

  const dispatch = useDispatch();

  const resetFormState = () => {
    dispatch(setIsFormActive(false));
    dispatch(setIsFormCreateMode(false));
    dispatch(setIsFormEditMode(false));
  };

  const adjustFavorite = (screenerID) => {
    const result = screenerCustom.map((el) => {
      if (Number(el.id) === Number(screenerID)) {
        return {
          ...el,
          favorite: el.favorite === 0 ? 1 : 0,
        };
      }
      return {
        ...el,
      };
    });

    setScreenerCustom(result);
  };

  const onClickFavoriteStar = (
    e: React.SyntheticEvent<EventTarget>,
    screenerID: number,
    screenerType: ScreenerTemplateType,
  ) => {
    e.stopPropagation();
    adjustFavorite(screenerID);
    dispatch(removeFavorite({ screenerID, screenerType }));
  };

  const onClickFavoriteLabel = (guruID: number, type: ScreenerTemplateType) => {
    resetFormState();
    dispatch(
      getScreener({
        screenerID: guruID,
        type,
      }),
    );
  };

  const onClickScreenerStar = (
    e: React.SyntheticEvent<EventTarget>,
    screenerID: number,
  ) => {
    e.stopPropagation();
    adjustFavorite(screenerID);
    dispatch(addFavorite({ screenerID, screenerType: 'TEMPLATE_TYPE_CUSTOM' }));
  };

  const onClickScreenerLabel = (guruID: number) => {
    resetFormState();
    dispatch(
      getScreener({
        screenerID: guruID,
        type: 'TEMPLATE_TYPE_CUSTOM',
      }),
    );
  };

  const onClickScreenerCross = (
    e: React.SyntheticEvent<EventTarget>,
    screenerID: number,
    screenerName: string,
  ) => {
    e.stopPropagation();
    setDeleteScreener((prevState) => ({
      ...prevState,
      id: screenerID,
      name: screenerName,
    }));
    setIsDeleteModalVisible(true);
  };

  const PopoverContent = () => (
    <ContentWrapper>
      {Menu({
        title: 'My Favorites',
        data: screenerFavorites,
        menuType: 'favorite',
        onClickStar: onClickFavoriteStar,
        onClickLabel: onClickFavoriteLabel,
        onClickCross: null,
      })}
      {Menu({
        title: 'ALL SCREENER',
        data: screenerCustom,
        menuType: 'all',
        onClickStar: onClickScreenerStar,
        onClickLabel: onClickScreenerLabel,
        onClickCross: onClickScreenerCross,
      })}
    </ContentWrapper>
  );

  const onClickCancelModal = () => {
    setIsDeleteModalVisible(false);
  };

  const onClickOkModal = (screenerID: number) => {
    dispatch(removeScreenerCustom({ id: screenerID }));
    setIsDeleteModalVisible(false);
  };

  useEffect(() => {
    dispatch(getScreenerCustom());
  }, []);

  useEffect(() => {
    setScreenerFavorites(dataFavorites);
  }, [dataFavorites]);

  useEffect(() => {
    setScreenerCustom(dataCustoms);
  }, [dataCustoms]);

  useEffect(() => {
    dispatch(getScreenerCustom());
  }, [dataRemoveCustomResult]);

  useEffect(() => {
    dispatch(getScreenerCustom());
  }, [screenerFavorites]);

  return (
    <>
      <Popover content={PopoverContent} placement="bottomRight" trigger="click">
        <SButton>
          <Flex justify="space-between" align="center">
            <Text padding="0 8px 0 0">Favorites</Text>
            <Iconmoon className="icon-toolbar_down" />
          </Flex>
        </SButton>
      </Popover>

      <DeleteModal
        isVisible={isDeleteModalVisible}
        title="Remove from favorites"
        screenerID={deleteScreener.id}
        screenerName={deleteScreener.name}
        onCancel={onClickCancelModal}
        onOk={onClickOkModal}
      />
    </>
  );
};

export default FavoriteDropdown;
